import React from 'react';

const StatusBadge = ({ 
  status, 
  variant = 'default',
  size = 'md',
  customColors = {},
  className = '' 
}) => {
  const defaultColors = {
    // Contract statuses
    'Draft': 'bg-gray-100 text-gray-800',
    'Generated': 'bg-blue-100 text-blue-800',
    'Sent': 'bg-yellow-100 text-yellow-800',
    'Accessed': 'bg-orange-100 text-orange-800',
    'Signed': 'bg-green-100 text-green-800',
    'Expired': 'bg-red-100 text-red-800',
    'Terminated': 'bg-red-100 text-red-800',
    
    // Romanian translations
    'Ciornă': 'bg-gray-100 text-gray-800',
    'Generat': 'bg-blue-100 text-blue-800',
    'Trimis': 'bg-yellow-100 text-yellow-800',
    'Accesat': 'bg-orange-100 text-orange-800',
    'Semnat': 'bg-green-100 text-green-800',
    'Expirat': 'bg-red-100 text-red-800',
    'Reziliat': 'bg-red-100 text-red-800',
    
    // Cron job statuses
    'Scheduled': 'bg-yellow-100 text-yellow-800',
    'Running': 'bg-blue-100 text-blue-800',
    'Completed': 'bg-green-100 text-green-800',
    'Failed': 'bg-red-100 text-red-800',
    'Cancelled': 'bg-gray-100 text-gray-800',
    
    // Romanian cron job translations
    'Programat': 'bg-yellow-100 text-yellow-800',
    'În execuție': 'bg-blue-100 text-blue-800',
    'Finalizat': 'bg-green-100 text-green-800',
    'Eșuat': 'bg-red-100 text-red-800',
    'Anulat': 'bg-gray-100 text-gray-800',
    
    // Generic statuses
    'Active': 'bg-green-100 text-green-800',
    'Inactive': 'bg-gray-100 text-gray-800',
    'Activ': 'bg-green-100 text-green-800',
    'Inactiv': 'bg-gray-100 text-gray-800'
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
    lg: 'px-3 py-1 text-sm'
  };

  const colors = { ...defaultColors, ...customColors };
  const colorClass = colors[status] || 'bg-gray-100 text-gray-800';

  return (
    <span className={`inline-flex items-center font-medium rounded-full ${sizes[size]} ${colorClass} ${className}`}>
      {status}
    </span>
  );
};

export default StatusBadge;